<template>
    <ModalComponent
        name="crearEntrada"
        :title="region ? 'Crear nuevo precio para el recinto anexo' : 'Crear nuevo precio'"
        v-on:close="() => close(false)"
    >

        <ValidationObserver tag="form" ref="observer" @submit.prevent="submit">
            <div class="row">
                <div class="col-12">
                    <FormEntrada :entrada="entrada" :sesion="sesion" />
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <Button type="submit" name="button" id="crear-precio-anexo">Crear</Button>
                </div>
            </div>
        </ValidationObserver>
    </ModalComponent>
</template>

<script>

    import ModalComponent from "@/components/backend/components/ModalComponent";
    import FormEntrada from '../FormEntrada';

    export default {
        props: ['sesion', 'region'],
        data() {
            return {
                entrada: {
                    price: 0,
                    dia_abonado: false,
                    acompanante_abonado: false,
                    amigo_abonado: false
                },
                loading: false
            }
        },
        methods: {
            close(creado) {
                this.$emit('close', 'crearEntrada', creado);
                this.entrada = {
                    price: 0,
                    unidades: 0,
                    dia_abonado: false,
                    acompanante_abonado: false,
                    amigo_abonado: false
                };
            },
            crearEntrada() {
                this.loading = true;

                this.entrada.filters = {};
                this.entrada.evento_id = this.$route.params.evento_id;
                this.entrada.sesion_id = this.$route.params.sesion_id;

                this.entrada.sale_start = moment(this.entrada.sale_start_zulu).format('YYYY-MM-DD HH:mm:ss');
                this.entrada.sale_stop = moment(this.entrada.sale_stop_zulu).format('YYYY-MM-DD HH:mm:ss');

                if (this.region) {
                    this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.plazas.tickets.crear'), this.entrada).then(res => {
                        this.$toast.success(res.data.message);
                        this.close(true);
                    }).finally(() => this.loading = false);   
                } else {
                    this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.tickets.crear'), this.entrada).then(res => {
                        this.$toast.success(res.data.message);
                        this.close(true);
                    }).finally(() => this.loading = false);
                } 
            },
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    this.crearEntrada();
                }
            },
        },
        components: {
            ModalComponent, FormEntrada
        }
    }
</script>
